/* eslint-disable import-helpers/order-imports */
import React, { useEffect, useState, FC } from 'react';

import 'core-js/features/array/at';

import { formatDate } from 'helpers';
import { useMember } from '../../hooks/useMember';

import MyAccountCard from './components/MyAccountCard';
import UpdateModal from '../../components/UpdateModal';

const MyAccountLegacy: FC<{ cardSize: string | null }> = ({ cardSize }) => {
  const { userData, tierData } = useMember();

  const [tierCookies] = useState(localStorage.getItem('tier-cookies'));
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const getLastTierTimeStamp = () => {
    const lastTier: any = tierData?.tierList.at(-1);
    if (lastTier) {
      const [month, day, year] = lastTier?.endDate.slice(0, 10).split('/');
      const date = new Date(+year, month - 1, +day);

      return date.getTime();
    }
    return undefined;
  };

  // const lastTwoCyclesTiersWherePrime = () => {
  //   if (tierData?.tierList.length > 1) {
  //     if (tierData?.tierList.at(-1).name === 'Prime' && tierData?.tierList.at(-2).name === 'Prime') {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return false;
  //   }
  // };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  const setModalToFire = (lastTierTimeStamp: any, timeStamp: any) => {
    // const daysToEndCycle = (lastTierTimeStamp - timeStamp) / (1000 * 60 * 60 * 24);

    if (!userData || !tierData) return;

    //  upgrades

    if (userData.tier === 'Essencial' && Number(tierData.userInfo?.upgradeInfo?.milesMaintenance) >= 100000) {
      setModalType('upgrade');
    }

    if (userData.tier === 'Prime' && Number(tierData.userInfo?.upgradeInfo?.milesMaintenance) >= 350000) {
      setModalType('upgrade');
    }

    if (userData.tier === 'Super Prime' && Number(tierData.userInfo?.upgradeInfo?.milesMaintenance) >= 1000000) {
      setModalType('upgrade');
    }

    // Downgrade
    // Prime to Essencial
    if (userData.tier === 'Prime' && Number(tierData.userInfo?.upgradeInfo?.milesMaintenance) < 100000) {
      setModalType('downgrade');
    }
    // Super Prime to Prime
    if (userData.tier === 'Super Prime' && Number(tierData.userInfo?.upgradeInfo?.milesMaintenance) < 350000) {
      setModalType('downgrade');
    }

    // Manutenção

    if (userData.tier === 'Essencial' && Number(tierData.userInfo?.upgradeInfo?.milesMaintenance) <= 99999) {
      setModalType('maintenance');
    }

    if (
      userData?.tier === 'Prime' &&
      Number(tierData?.userInfo?.upgradeInfo?.milesMaintenance) >= 350000 &&
      Number(tierData?.userInfo?.upgradeInfo?.milesMaintenance) <= 999999
    ) {
      setModalType('maintenance');
    }

    if (userData?.tier === 'Super Prime' && Number(tierData?.userInfo?.upgradeInfo?.milesMaintenance) >= 1000000) {
      setModalType('maintenance');
    }
  };

  useEffect(() => {
    const lastTierTimeStamp = getLastTierTimeStamp();
    const timeStamp = Date.now();
    setModalToFire(lastTierTimeStamp, timeStamp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tierData, userData]);

  useEffect(() => {
    if (modalType !== tierCookies && modalType !== '') {
      setTimeout(() => {
        setOpenModal(true);
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalType, userData?.fantasyName]);

  return (
    <>
      {userData && tierData && (
        <>
          <section className="my-account-section">
            <div className="my-account-section__content">
              <MyAccountCard
                user={userData.socialReason}
                tier={userData.tier}
                voeBizNumber={tierData.userInfo?.memberNumber}
                voeBizPoints={userData.milesBalance}
                voeBizExpiringPoints={userData.milesToExpire}
                voeBizExpiringDate={formatDate(userData.milesNextExpirationDate.slice(0, 10))}
                voeBizQualifyingPoints={tierData.userInfo?.upgradeInfo?.totalMilesClub ?? ''}
                voeBizQualifyPointsToNextTier={tierData.userInfo?.upgradeInfo?.milesUpgrade}
                voeBizNextTier={
                  userData.tier === 'Prime'
                    ? tierData.userInfo?.upgradeInfo?.milesMaintenance
                    : tierData.userInfo?.upgradeInfo?.nextTier
                }
                voeBizRenewCategoryDate={formatDate(tierData.userInfo?.dateUpgradeLimit.slice(0, 10))}
                cardSize={cardSize}
              />
            </div>
            <UpdateModal
              isOpen={openModal}
              handleClose={() => setOpenModal(false)}
              modalType={modalType}
              nextTier={tierData.userInfo?.upgradeInfo?.nextTier}
              tier={userData.tier}
            />
          </section>
        </>
      )}
    </>
  );
};

export default MyAccountLegacy;
